import React from 'react'
import useSWRImmutable from 'swr/immutable'

import { getCompany, getCompanySubDivision } from '../../../api/companies'
import Loading from '../../components/layout/Loading'
import CompanyProfileLogo from '../../components/companies/ProfileLogo'
import Tag from '../../components/content/Tag'
import CompanyCoverImage from '../../components/companies/CoverImage'
import PositionsTabs from './positions/Tabs'
import GoBackLink from '../../components/layout/GoBackLink'
import PageSection from '../../components/layout/PageSection'
import NavigationBreadcrumbs from '../../components/layout/NavigationBreadcrumbs'
import { useI18N } from '../../../libraries/i18n/hook'
import DescriptionText from '../../components/content/DescriptionText'

type Props = { companyId: number, divisionId: number, subDivisionId: number }
const CompanySubDivisionProfile: React.FC<Props> = ({ companyId, divisionId, subDivisionId }) => {
  const { t } = useI18N()
  const { data: subDivisionData, isLoading: isLoadingSubDivision } = useSWRImmutable(['company', companyId, 'sub-divisions', subDivisionId], () => getCompanySubDivision(companyId, subDivisionId))
  const { data: companyData, isLoading: isLoadingCompany } = useSWRImmutable(['company', companyId], () => getCompany(companyId))

  if(!subDivisionData || !companyData || isLoadingCompany || isLoadingSubDivision) {
    return <Loading />
  }

  return (
    <div className='flex flex-col text-deep-green'>
      <div className='hidden sm:block ml-auto mb-5'><GoBackLink /></div>
      <div className='sm:flex items-start'>
        <div className='sm:w-3/4'>
          <div className='flex gap-x-3 sm:gap-x-6 items-center'>
            <div className='inline-block sm:hidden'><GoBackLink /></div>
            <CompanyProfileLogo src={companyData.logoSrc} alt={companyData.name} />
            <div className='inline-flex flex-col'>
              <div className='hidden sm:block'><NavigationBreadcrumbs links={[{ label: t('menu.home', undefined, companyData.languageCode), to: '/' }, { label: t('companies.title', undefined, companyData.languageCode), to: '/companies' }, { label: <strong>{companyData.name}</strong>, to: `/companies/${companyData.id}`}]}/></div>
              <h1 className='leading-none my-1'>{subDivisionData.name}</h1>
              <div className='hidden sm:inline-block'><Tag outlined>{companyData.industry.name}</Tag></div>
            </div>
          </div>
          <div className='block mt-4 ml-8 sm:hidden'>{<Tag outlined>{companyData.industry.name}</Tag>}</div>
          <div className='pr-0 sm:pr-10 mt-6'>
            <DescriptionText size='m'>{subDivisionData.description}</DescriptionText>
          </div>
        </div>
        <div className='sm:w-1/4 mt-16 mb-8 sm:mt-0 sm:ml-auto '>
          <div className='w-full'>
            <CompanyCoverImage src={companyData.coverSrc} alt={companyData.name} />
          </div>
        </div>
      </div>
      <PageSection title=''>
        <PositionsTabs positions={subDivisionData.positions} companyId={companyId} divisionId={divisionId} />
      </PageSection>
    </div>
  )
}

export default CompanySubDivisionProfile
